import { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import { GOOGLE_API_URL } from "@/utils/constants";
const SCRIPT_ID = "google-places-api-script";
const useGooglePlacesAPI = () => {
    const [autocompleteService, setAutocompleteService] = useState(null);
    const [placesService, setPlacesService] = useState(null);
    const createServices = useCallback(() => {
        setTimeout(() => {
            try {
                setAutocompleteService(new google.maps.places.AutocompleteService());
                setPlacesService(new google.maps.places.PlacesService(document.createElement("div")));
            }
            catch (error) {
                message.error("Google Maps could not be loaded, address autocomplete will not work");
            }
        }, 1000);
    }, []);
    useEffect(() => {
        if (!document.getElementById(SCRIPT_ID)) {
            const script = document.createElement("script");
            script.id = SCRIPT_ID;
            script.src = GOOGLE_API_URL;
            script.onload = createServices;
            document.body.appendChild(script);
        }
        else {
            createServices();
        }
    }, [createServices]);
    return [placesService, autocompleteService];
};
export default useGooglePlacesAPI;
